import { PatientPayload } from '_api/types';
import dayjs from 'dayjs';

const DefaultNewPatient: PatientPayload = {
  firstName: '',
  lastName: '',
  dateOfBirth: dayjs().format('MM/DD/YYYY'),
  diagnosis: [],
  // ethnicity: '',
  // gender: '',
  // race: '',
  // sex: '',
  therapistIds: [],
  imageUrl: '',
  mrn: '',
  access: '',
  points: 0,
  secretWord: '',
  themeIndex: 0,
};

export default DefaultNewPatient;
